@if (viewModel$ | async; as vm) {
  <wl-calculate-card
    [title]="titleField"
    [subTitle]="descriptionField"
    [sticker]="sticker"
  >
    <form novalidate [wlTrackStep]="trackToolConfig.forStep('wizard')">
      <p class="mb-1 fw-bold" *scText="deliveryAddressTitleField"></p>
      <wl-postal-address-form
        [rendering]="rendering"
        [content]="postalFormContent"
        [formState]="vm.formState"
        [trackStep]="trackToolConfig.forStep('wizard')"
      ></wl-postal-address-form>

      <div class="row g-1 mt-2 mb-4">
        <div class="col-12">
          @if (rendering.fields.BuildingTypeLabel) {
            <label
              class="fw-bold mb-1"
              for="buildingtype"
              *scText="rendering.fields.BuildingTypeLabel"
            ></label>
          }
          <wl-dropdown
            [wlTrackValueChange]="{
              step: trackToolConfig.step('wizard'),
              stepName: trackToolConfig.stepName('wizard'),
              rendering: rendering,
              label: rendering.fields.BuildingTypeLabel.value,
              inputLabel: vm.formState.controls.buildingType.value || '',
              sendValue: true,
              trackFocus: true,
            }"
            [dropdownItems]="buildingTypes"
            [formsControl]="vm.formState.controls.buildingType"
            [floatingLabel]="false"
            [placeholder]="rendering.fields.BuildingTypePlaceholder.value"
            icon="house"
            labelForId="buildingtype"
            wlAutomationId="insulation-wizard-building-type"
          ></wl-dropdown>
        </div>
        @if (vm.formState.controls.buildingType | isInvalid) {
          <div class="col-12">
            @if (vm.formState.controls.buildingType.errors?.required) {
              <wl-input-error
                [automationId]="
                  'insulation-wizard-building-type-required-error'
                "
                [messageField]="rendering.fields.BuildingTypeRequiredError"
                messageDescription="type gebouw"
                [rendering]="rendering"
                [stepName]="trackToolConfig.stepName('wizard')"
              ></wl-input-error>
            }
          </div>
        }
      </div>

      <div class="row g-1 mb-4">
        <div class="col-12">
          <wl-checkbox
            [step]="trackToolConfig.step('wizard')"
            [stepName]="trackToolConfig.stepName('wizard')"
            [rendering]="rendering"
            [formsControl]="vm.formState.controls.houseIsBought"
            [label]="houseIsBoughtLabel"
            [tooltip]="houseIsBoughtTooltip"
          ></wl-checkbox>
        </div>
      </div>

      <div class="row g-1 mt-2 mb-1">
        <div class="col-12">
          <button
            (click)="submit($event, vm.formState.isValid)"
            wlTrackLink
            [trackLinkInfo]="{
              eventType: 'button-click',
              rendering: rendering,
              field: submitButtonTextField?.value,
            }"
            class="btn btn-sales-primary calculate__submit-button w-100"
            wlAutomationId="insulation-panels-wizard-submit-button"
            *scText="submitButtonTextField"
          ></button>
        </div>
      </div>
      @if (secondaryButton.link?.href) {
        <div class="row g-1 my-1">
          <div class="col-12">
            <a
              class="w-100"
              wlAutomationId="insulation-panels-wizard-secondary-button"
              *wlGenericLink="secondaryButton.link"
              [ngClass]="['mb-0 mt-0', secondaryButton.style]"
              wlTrackLink
              [trackLinkInfo]="{
                eventType: 'button-click',
                rendering: rendering,
                field: secondaryButton.link.href,
              }"
            ></a>
          </div>
        </div>
      }
    </form>
  </wl-calculate-card>
}
